import { useEffect } from "react";

/** Causes the page to scroll to the top when it loads */
export const useScrollToTop = (behavior?: ScrollBehavior) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: behavior ?? ("instant" as ScrollBehavior),
    });
  }, []);
};
